import React, { useState } from 'react';
import { Button, Modal, Text, Box } from '@nerdwallet/currency';
import {
  Impression,
  ImpressionContext,
} from '@nerdwallet/analytics/react/impression';

import styles from './save-modal.module.less';
import { ArticleTemplateProps } from '~/lib/types';
import { trackElementInteracted } from '../../../lib/analytics.helper';

type SaveModalProps = {
  onClose: () => void;
  isOpen: boolean;
  article: ArticleTemplateProps['graphqlArticle'];
};

const FIRST_PARAGRAPH =
  'The ability to save articles on NerdWallet is under construction.';

const SECOND_PARAGRAPH =
  'In the meantime, you can keep track of your favorite NerdWallet articles — and revisit them any time — by sending them to your inbox.';

const MAIL_BODY = 'Check out this article from NerdWallet.';

export const SaveModal: React.FC<SaveModalProps> = ({
  onClose,
  isOpen,
  article,
}) => {
  const mailToLink = `mailto:?subject=${article.title}&body=${MAIL_BODY}%0D%0A%0D%0A${article.link}`;
  const [activeImpressionId, setActiveImpressionId] = useState('');

  return (
    <Modal
      title="This feature is in development"
      isOpen={isOpen}
      onRequestClose={() =>
        trackElementInteracted({
          entityName: 'article_save_article_thank_you_modal_user_click_x',
          action: 'select',
          interactionType: 'press',
          impressionId: activeImpressionId,
          onClick: onClose,
        })
      }
      titleElementId={styles['save-modal-title']}
    >
      <Impression
        entityName="article_save_article_thank_you_modal_successful_display"
        eventType="element_impression"
      >
        <ImpressionContext.Consumer>
          {(impressionContext) => {
            setActiveImpressionId(impressionContext?.impressionId);

            return (
              <React.Fragment>
                <Box flexDirection="column" display="flex" gridGap="4">
                  <Text size="large">{FIRST_PARAGRAPH}</Text>
                  <Text size="large">{SECOND_PARAGRAPH}</Text>
                </Box>
                <Box
                  flexDirection="column"
                  display="flex"
                  gridGap="3"
                  marginTop="3"
                >
                  <Button
                    href={mailToLink}
                    target="_blank"
                    primary
                    block
                    onClick={() =>
                      trackElementInteracted({
                        entityName:
                          'article_save_article_thank_you_modal_user_click_email_article',
                        action: 'select',
                        interactionType: 'press',
                        impressionId: impressionContext?.impressionId,
                      })
                    }
                  >
                    email this article
                  </Button>
                  <Button
                    secondary
                    block
                    onClick={() =>
                      trackElementInteracted({
                        entityName:
                          'article_save_article_thank_you_modal_user_close',
                        action: 'select',
                        interactionType: 'press',
                        impressionId: impressionContext?.impressionId,
                        onClick: onClose,
                      })
                    }
                  >
                    close
                  </Button>
                </Box>
              </React.Fragment>
            );
          }}
        </ImpressionContext.Consumer>
      </Impression>
    </Modal>
  );
};
